export default __webpack_public_path__ + "static/media/706.2a3cdc07.svg";